import React, { memo } from "react";
import intl from "../../../../i18n/intl";
import ShopifyModal from "../../../../components/ShopifyModal";

const ArchiveOrderModal = memo(
  ({ bulkSourceData ,setBulkSourceData}) => {
    return (
      <div>
        <ShopifyModal
          id="sourcing-order-tip-modal"
          open={bulkSourceData.sourcingTip}
          onClose={() => setBulkSourceData((prevValue)=>({
            ...prevValue,
            sourcingTip:false,
            isBluk:true
          }))}
          heading={intl.get("Sourcing Request Sent")}
          secondaryActions={[
            {
              content: intl.get("Got it"),
              onAction: () =>  setBulkSourceData((prevValue)=>({
                ...prevValue,
                sourcingTip:false,
                isBluk:true
              })),
            },
          ]}
        >
            {`The sourcing request for ${bulkSourceData.isBluk ? "these orders" : "this order"}  has already been initiated, no need to send ${bulkSourceData.isBluk ? "" : "it"} again.`}
        </ShopifyModal>
      </div>
    );
  }
);

export default ArchiveOrderModal;
